import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Exit16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M3.05027 3.05027C3.35281 2.74773 3.84332 2.74773 4.14587 3.05027L8.00002 6.90442L11.8542 3.05027C12.1567 2.74773 12.6472 2.74773 12.9498 3.05027C13.2523 3.35281 13.2523 3.84333 12.9498 4.14587L9.09561 8.00002L12.9498 11.8542C13.2523 12.1567 13.2523 12.6472 12.9498 12.9498C12.6472 13.2523 12.1567 13.2523 11.8542 12.9498L8.00002 9.09561L4.14587 12.9498C3.84332 13.2523 3.35281 13.2523 3.05027 12.9498C2.74773 12.6472 2.74773 12.1567 3.05027 11.8542L6.90442 8.00002L3.05027 4.14587C2.74773 3.84333 2.74773 3.35281 3.05027 3.05027Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
